export const AGE_DICT = [
    {__id: 'paeds', __description: 'Paeds'},
    {__id: 'adult', __description: 'Adult'},
    {__id: 'over75', __description: 'Over75'},
];